// Common API's
const GetWorkOrderTypesAndCategories = 'Common/GetWorkOrderTypesAndCategories'
const GetWorkorderStages = 'Common/GetWorkorderStages'
const GetCountryStates = 'Common/GetCountryStates'
const GetDocumentTemplateData = 'Common/GetDocumentTemplateData'
const GetUserCompanies = 'Company/GetUserCompanies'

// Dashboard API's
const GetCustomerWorkorders = 'Dashboard/GetCustomerWorkorders'
const FilterWorkorders = 'Dashboard/FilterWorkorders'
const GetVesselDashboard = 'getVesselDashboard'
const GetUsers = 'UserManagement/GetUsers'
const GetUserRoles = 'UserManagement/GetUserRoles'
const SaveUserRoles = 'UserManagement/SaveUserRoles'

// Company API's
const GetSFCompaniesByName = 'Company/GetSFCompaniesByName'
const CreateCompany = 'Company/CreateCompany'
const GetCompanyDetails = 'Company/GetSSCompanyList'
const GetParentCompany = 'GetParentCompany'
const ValidateClient = 'ValidateClient'
const ValidateWorkorderCreation = 'ValidateWorkorderCreation'

// Workorders API's
const GetBaseWorkOrderData = 'GetBaseWorkOrderData'
const CreateWorkorder = 'CreateWorkorder'
const UpdateWorkorderData = 'UpdateWorkorderData'
const GetWorkorderById = 'GetWorkorderById'
const UpdateWorkorder = 'UpdateWorkorder'
const RemoveWorkorderDocument = 'FileUpload/RemoveWorkorderDocument'
const RequestMoreInfo = 'RequestMoreInfo'
const GetInvoiceDocument = 'GetInvoiceDocument'
const GetPreviewDocument = 'PreviewAuthorizationDocument'
const PreviewLLABDocument = 'PreviewLLABDocument'
const UpdateNeedMoreInfoStatus = 'UpdateNeedMoreInfoStatus'
const CancelWorkorder = 'CancelWorkorder'
const ArchivedWorkorder = 'ArchivedWorkorder'
const ResendDocusignEmail = 'ResendDocusignEmail'
const SendAcknowledgementMail = 'SendAcknowledgementMail'
const GetAuthorizationDocument = 'GetAuthorizationDocument'
const ValidateVesselDetails = 'ValidateVesselDetails'
const GetWorkOrderFilesByFileId = 'FileUpload/GetWorkOrderFilesByFileId'
const GetVesselOwnersData = 'GetVesselOwnersData'
const GetVendorsData = 'GetVendorsData'
const GetAllVendorsData = 'GetAllVendorsData'
const GetBillableVoyAges = 'GetBillableVoyAges'
const GetUpdatedBillableVoyages = 'GetUpdatedBillableVoyages'
const GetCompanyAddressdetails = 'Company/GetCompanyAddressdetails'
const GetAllProducts = 'GetAllProducts'
const GetCurrentQBbyCompany = 'GetCurrentQBbyCompany'
const GetERBPCListByIMONumber = 'GetERBPCListByIMONumber'
const GetProductsDataByIMONumber = 'GetProductsDataByIMONumber'
const GetVesselDetailsByIMONumber = 'GetVesselDetailsByIMONumber'
const GetClassesList = 'GetClassesList'
// Workorder Comments Api's
const GetWorkorderComments = 'WorkorderComment/GetWorkorderComments'
const CreateComment = 'WorkorderComment/CreateComment'

// IHM SOC API's
const GetAllVesselsByAccountId = 'GetAllVesselsByAccountId'
const GetVesselByofficialnumber = 'GetVesselByOfficialNumber'
const GetVesselByIMONumber = 'GetVesselByIMONumber'
const GetSoftwareVersionPClist = 'GetSoftwareVersionPClist'
const ResendEmails = 'ResendEmails'
const UpdateBillingPrefix = 'UpdateBillingPrefix'
const UpdateResendEmail = 'ResendEmail'
const RegenerateAuthorizationLetter = 'RegenerateAuthorizationLetter'
const UpdateNdaDocument = 'UpdateNdaDocument'
const GetVesselSyncData = 'GetVesselSyncData'
//RLM
const GetListFiles = "GetListFiles"
const GetAllActiveVaultsForUser = "GetActiveVaultsForUser"
const UpdateCustomerVault = "UpdateCustomerVault"
const DownloadFile = "DownloadFile"
const GetCompanyAddress = "Company/GetCompanyAddressdetails"
const GetLastModifiedFiles = "GetLastModifiedFiles"
const GetSearchLibrary = "SearchLibrary"

// Investigation
const GetPortCities = 'GetPortCities'
const GetPortByName = "GetPortByName"
const GetInspectorByName = 'GetInspectorByName'
const GetInvestigatorByCityId = 'GetInvestigatorByCityId'
const GetAllInvestigators = 'GetAllInvestigators'
const GetExpenseProducts = 'GetExpenseProducts'
const GetVesselByIMO = 'GetVesselByIMO'
const GetInspectorDetailsByPortId = "GetInspectorDetailsByPortId"

export const ApiUrls = {
  GetWorkOrderTypesAndCategories,
  GetWorkorderStages,
  GetCountryStates,
  GetDocumentTemplateData,
  GetUserCompanies,

  GetCustomerWorkorders,
  FilterWorkorders,
  GetVesselDashboard,
  GetUsers,
  GetUserRoles,
  SaveUserRoles,
  GetCompanyDetails,
  GetParentCompany,
  ValidateClient,

  GetSFCompaniesByName,
  CreateCompany,
  ValidateWorkorderCreation,

  GetBaseWorkOrderData,
  CreateWorkorder,
  UpdateWorkorderData,
  GetWorkorderById,
  UpdateWorkorder,
  RemoveWorkorderDocument,
  RequestMoreInfo,
  GetInvoiceDocument,
  GetPreviewDocument,
  PreviewLLABDocument,
  UpdateNeedMoreInfoStatus,
  CancelWorkorder,
  ArchivedWorkorder,
  ResendDocusignEmail,
  SendAcknowledgementMail,
  ValidateVesselDetails,
  GetWorkOrderFilesByFileId,
  GetVesselOwnersData,
  GetVendorsData,
  GetAllVendorsData,
  GetBillableVoyAges,
  GetUpdatedBillableVoyages,
  GetCompanyAddressdetails,
  GetAllProducts,
  GetCurrentQBbyCompany,
  GetWorkorderComments,
  CreateComment,

  GetAuthorizationDocument,
  GetAllVesselsByAccountId,
  GetVesselByofficialnumber,
  GetVesselByIMONumber,
  ResendEmails,
  UpdateBillingPrefix,
  UpdateResendEmail,
  RegenerateAuthorizationLetter,
  GetVesselDetailsByIMONumber,
  GetERBPCListByIMONumber,
  GetProductsDataByIMONumber,
  GetSoftwareVersionPClist,
  GetListFiles,
  GetAllActiveVaultsForUser,
  UpdateCustomerVault,
  DownloadFile,
  GetCompanyAddress,
  GetLastModifiedFiles,
  GetSearchLibrary,
  UpdateNdaDocument,
  GetVesselSyncData,
  GetPortByName,
  GetPortCities,
  GetInvestigatorByCityId,
  GetAllInvestigators,
  GetInspectorByName,
  GetInspectorDetailsByPortId,
  GetExpenseProducts,
  GetVesselByIMO,
  GetClassesList
}
